import React from 'react';
import AuthContainer from '../AuthContainer';
import { getObjFromLS } from '../../Helpers';

const AccountnotConfirmed = (props) => {
  localStorage.setItem("redirect", true)
  let detail = JSON.parse(localStorage.getItem("wordpress"))
  if (!detail) {
    detail = getObjFromLS("userdetail")
  }
  const subtitle =
    (detail.name) ?
      [`Hello ${detail.name}`, <br />, <b>{detail.email}</b>, <br />, <br />, `Your account is not confirmed.`]
      : [
        "Your account is not yet confirmed.",
        <br />,
        "We have sent a verification message to ",
        <b>{detail.email}</b>,
        ".",
        <br />,
        "Please follow the instructions  to verify  your account."
      ];
  return (
    <AuthContainer title='Account Not Confirmed' subtitle={subtitle} linkdisable >
      <button
        id="click_login_button"
        className="button--full-width"
        type="submit"
        onClick={() => props.history.push('/')}
      >
        Back
      </button>
    </AuthContainer>
  );
};

export default AccountnotConfirmed;